export default class ConsultationForm {
    static init(): void {
        const form = document.querySelector('.consultation-form');
        const formSubmit = form?.querySelector('.consultation-form__submit') as HTMLButtonElement;
        const selectboxes = form?.querySelectorAll('select[required="required"]') as NodeListOf<HTMLSelectElement>;

        if (!formSubmit || !form || !selectboxes) {
            return;
        }

        const inputs = form.querySelectorAll('input');

        selectboxes.forEach((selectbox) => {
            selectbox.addEventListener('change', () => {
                this.validateForm();
            });
        });

        inputs.forEach((input) => {
            input.addEventListener('change', () => {
                this.validateForm();
            });
        });

        formSubmit.addEventListener('click', (e) => {
            e.preventDefault();
            this.validateForm(formSubmit);
        });

    }

    static validateForm(submitButton?: HTMLButtonElement): void {
        const form = document.querySelector('.consultation-form') as HTMLFormElement;
        const inputs = form?.querySelectorAll('input[required="required"]') as NodeListOf<HTMLInputElement>;
        const selectboxes = form?.querySelectorAll('select[required="required"]') as NodeListOf<HTMLSelectElement>;
        const smartformControls = form?.querySelectorAll('[data-smartform-control]') as NodeListOf<HTMLInputElement>;

        if (!inputs || !form) {
            return;
        }

        let elements = 0;
        let validElements = 0;
        selectboxes.forEach((selectbox) => {
            elements++;
            if (!selectbox.value) {
                if (selectbox.classList.contains('nice-select')) {
                    selectbox.classList.add('nice-select--error');
                }
            } else {
                selectbox.classList.remove('nice-select--error');
                validElements++;
            }
        });

        let invalidaInputs: HTMLInputElement[] = [];
        inputs.forEach((input) => {
            elements++;
            if (!input.value) {
                invalidaInputs.push(input);
                input.classList.add('form-control--error');
                return;
            } else {
                if (input.getAttribute('name') === 'email') {
                    if (!this.validateEmail(input.value)) {
                        invalidaInputs.push(input);
                        input.classList.add('form-control--error');
                        return;
                    } else {
                        validElements++;
                        input.classList.remove('form-control--error');
                    }
                } else if (input.getAttribute('name') === 'tel') {
                    input.value = this.getPhone(input.value);
                    if (!this.validatePhone(input.value)) {
                        invalidaInputs.push(input);
                        input.classList.add('form-control--error');
                        return;
                    } else {
                        validElements++;
                        input.classList.remove('form-control--error');
                    }
                } else if (input.getAttribute('name') === 'zip') {
                    if (input.value && !input.classList.contains('form-control--error')) {
                        validElements++;
                    }
                } else if (input.getAttribute('name') === 'gdpr') {
                    if (input.checked) {
                        input.classList.remove('form-control--error');
                        validElements++;
                    } else {
                        invalidaInputs.push(input);
                        input.classList.add('form-control--error');
                    }
                } else {
                    validElements++;
                    input.classList.remove('form-control--error');
                }
            }
        });

        smartformControls.forEach((control) => {
            elements++;
            if (!control.hasAttribute('required') && control.value === '') {
                control.classList.remove('form-control--error');
            }
            if (control.classList.contains('form-control--error')) {
                invalidaInputs.push(control as HTMLInputElement);
            } else {
                validElements++;
            }
        });

        if (invalidaInputs.length > 0) {
            if (submitButton) {
                invalidaInputs[0].focus();
            }
        } else if (validElements === elements) {
            if (submitButton) {
                // show .loader
                const loader = document.querySelector('.loader');
                if (loader) {
                    // set display block
                    loader.classList.add('loader--visible');
                }
                form.submit();

            }
        }
    }

    static validateEmail(email: string): boolean {
        // min 2 znaky po poslední tečce
        const re = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
        return re.test(email);
    }

    static getPhone(phone: string): string {
        phone = phone.replace(/\s/g, '');
        phone = phone.replace(/[^0-9+]/g, '');

        if (phone.startsWith('00')) {
            phone = phone.replace('00', '+');
        }

        let phonePrefix = '';
        if (phone.startsWith('+420') || phone.startsWith('+421') || phone.startsWith('+380')) {
            phonePrefix = phone.substring(0, 4);
            phone = phone.substring(4);
        } else if (phone.startsWith('+43') || phone.startsWith('+48') || phone.startsWith('+49') || phone.startsWith('+84')) {
            phonePrefix = phone.substring(0, 3);
            phone = phone.substring(3);
        }

        if (phone.length > 0) {
            phonePrefix += ' ';
        }

        return phonePrefix + phone;
    }

    static validatePhone(phone: string): boolean {
        let result = false;

        if (phone.startsWith('+420')) {
            result = /^(\+420)? ?[1-9][0-9]{2} ?[0-9]{3} ?[0-9]{3}$/g.test(phone);
        } else if (phone.startsWith('+421')) {
            result = /^(\+421)? ?[1-9][0-9]{2} ?[0-9]{3} ?[0-9]{3}$/g.test(phone);
        } else if (phone.startsWith('+380')) {
            result = /^(\+380)? ?[1-9][0-9]{2} ?[0-9]{3} ?[0-9]{3}$/g.test(phone);
        } else if (phone.startsWith('+48')) {
            result = /^(\+48)? ?[1-9][0-9]{2} ?[0-9]{3} ?[0-9]{3}$/g.test(phone);
        } else if (phone.startsWith('+43')) {
            result = /^(\+43)? ?[1-9][0-9]{2} ?[0-9]{3} ?[0-9]{3}$/g.test(phone);
        } else if (phone.startsWith('+49')) {
            if (phone.length >= 12 && phone.length <= 15) {
                result = true;
            }
        } else if (phone.startsWith('+84')) {
            if (phone.length >= 12 && phone.length <= 15) {
                result = true;
            }
        } else {
            // remove spaces
            phone = phone.replace(/\s/g, '');
            // min 9 numbers without another characters
            if (phone.length >= 9) {
                result = /^[0-9]{9,15}$/g.test(phone);
            }
        }

        return result;
    }

}
